import {
    FETCH_COMBINED_PRACTITIONER_REQUEST,
    FETCH_COMBINED_PRACTITIONER_SUCCESS,
    FETCH_COMBINED_PRACTITIONER_FAILURE,
  } from "./FetchCombinedPractitionerListTypes";
  
  const initialState = {
    loading: false,
    combinedPractitioners: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_COMBINED_PRACTITIONER_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_COMBINED_PRACTITIONER_SUCCESS:
        return {
          loading: false,
          combinedPractitioners: action.payload,
          error: "",
        };
      case FETCH_COMBINED_PRACTITIONER_FAILURE:
        return {
          loading: false,
          combinedPractitioners: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  